import React, {useState, useEffect} from 'react'
import {Link} from 'react-router-dom'
import Logo from './Logo';
import phone from "../images/icons/phone.png"
import menuIcon from "../images/icons/menu-icon.png"



const visibleMenu = {display: "flex"};
const hiddenMenu = {display: "none"};

function MobileNavigation() {

    const [showMenu, setShowMenu] = useState(false);
    const [menuStatus, setMenuStatus] = useState(hiddenMenu);

    // useEffect( () => {
    //   handleToggleMenu();
    // }, [])
    const handleToggleMenu = () => {
      if(showMenu){
        setMenuStatus(hiddenMenu);
      }else{
        setMenuStatus(visibleMenu);
      }

      setShowMenu( (prev) =>  !prev);

    }
    const handleHideMenu = () => {
      setShowMenu(true);
      handleToggleMenu();
    }

  return (
    <header id= "mobile-nav">
    {/* <img id= "menuIcon" src={menuIcon} alt="Menu icon" /> */}
    <button id= "menuIcon" onClick= {handleToggleMenu}>☰</button>
      <ul className= "navbar" style={menuStatus}>
        
            <Link to="/" onClick= {handleHideMenu}><li>Home</li></Link>
        
        
            <Link to="/Services" onClick= {handleHideMenu}><li>Services</li></Link>
        
        
            <Link to="/Estimate" onClick= {handleHideMenu}><li>Estimate</li></Link>
        
      </ul>
      <Logo/>
      <a id= "call-icon" href="tel:781-228-8783"><img src={phone} alt="" /></a>
    </header>
  )
}

export default MobileNavigation